export const TEMPLATE_LIST_DEFAULT_QUERY = {
  page: 1,
  limit: 10,
  search: '',
  status: '',
  pricing: '',
  sortBy: 'createdAt',
  sortOrder: 'desc',
};

const allowedValues = {
  status: ['', 'published', 'unpublished'],
  pricing: ['', 'free', 'premium'],
  sortBy: ['tempId', 'name', 'categories', 'createdAt', 'updatedAt'],
  sortOrder: ['asc', 'desc'],
};

const getPositiveInteger = (value, fallback, maximum) => {
  const parsed = Number.parseInt(value, 10);
  if (!Number.isFinite(parsed) || parsed < 1) return fallback;
  return Math.min(parsed, maximum);
};

export const getTemplateListQueryFromSearch = searchString => {
  const params = new URLSearchParams(searchString || '');
  const query = {
    ...TEMPLATE_LIST_DEFAULT_QUERY,
    page: getPositiveInteger(params.get('page'), 1, 100000),
    limit: getPositiveInteger(params.get('limit'), 10, 100),
    search: String(params.get('search') || '').trim().slice(0, 100),
  };

  Object.keys(allowedValues).forEach(key => {
    const value = params.get(key);
    if (value !== null && allowedValues[key].includes(value)) query[key] = value;
  });

  return query;
};

export const getTemplateListSearchFromQuery = query => {
  const params = new URLSearchParams();
  const normalized = { ...TEMPLATE_LIST_DEFAULT_QUERY, ...query };

  Object.keys(normalized).forEach(key => {
    const value = normalized[key];
    if (value === TEMPLATE_LIST_DEFAULT_QUERY[key] || value === '') return;
    params.set(key, String(value));
  });

  const result = params.toString();
  return result ? `?${result}` : '';
};

export const getEffectiveTemplateSearch = value => {
  const normalized = String(value || '').trim();
  if (normalized.length > 0 && normalized.length < 3) return null;
  return normalized;
};

export const getTemplateEditPath = id => (
  `/template/${encodeURIComponent(String(id || ''))}/edit`
);

export const getTemplateDesignUrl = (baseUrl, id, tempId) => (
  `${String(baseUrl || '').replace(/\/$/, '')}/edit/template/`
  + `${encodeURIComponent(String(id || ''))}/${encodeURIComponent(String(tempId || ''))}`
);

export const getTemplatePreviewUrl = (baseUrl, template, refreshVersion) => {
  const version = [template.updatedAt || '', refreshVersion || ''].join(':');
  return `${String(baseUrl || '').replace(/\/$/, '')}/resources/templates/`
    + `${encodeURIComponent(String(template._id || ''))}/thumbnail.png`
    + `?v=${encodeURIComponent(version)}`;
};

export const getTemplateManagementRequestParams = ({ search, ...query }) => {
  const params = { ...query, q: search };
  Object.keys(params).forEach(key => {
    if (params[key] === '' || params[key] === undefined || params[key] === null) {
      delete params[key];
    }
  });
  return params;
};
